import React from "react";
import BootstrapTable from "react-bootstrap-table-next";
import "../General/NotificationStyle.css";
import RecipientModal from "../General/RecipientModal";
import { useDispatch } from "react-redux";
import actions from "../../../store/notificatiommodule/action";
import Services from "../General/NotificationService";
import { toast } from "react-toastify";
import $ from "jquery";
import RecipientTable from "./RecipientTable";
import PermissionFeature from "../../Permissions/PermissionFeature";

import { connect } from "react-redux";
import AuthService from "../../Auth/AuthService";

// Level 2: Trigger Table (with expand for recipients)
class TriggerTable extends React.Component {
  state = {
    showModal: false,
    selectedTrigger: null,
  };

  handleTriggerStatusChange = async (row, checked) => {
    $(".loading").show();
    const { fetchNotifications } = this.props;
    try {
      const response = await Services.updateTriggerStatus(row.id, checked);

      if (response) {
        // reload notifications
        fetchNotifications(true);
      } else {
        toast.error(response.message);
      }
    } catch (error) {
      console.log(error);
      toast.error("Failed to update Trigger status.");
    }
    $(".loading").hide();
  };

  openModal = (trigger) => {
    this.setState({
      showModal: true,
      selectedTrigger: trigger,
    });
  };

  handleSaveRecipients = (recipients) => {
    const { selectedTrigger } = this.state;

    // 🔥 API CALL HERE
    console.log("Save for trigger:", selectedTrigger.id, recipients);
  };
  columns = () => {
    return [
      {
        headerClasses:
          "text-nowrap bg-primary text-white px-sm-3 px-2 py-4 rounded-left",
        dataField: "trigger_Key",
        headerStyle: {
          width: "80%",
        },
        text: "Trigger",
        formatter: (cell, row) => {
          let hasRecipients = row.recipients && row.recipients.length > 0;
          return (
            <div
              className={
                "w-100 px-3 py-2" + (hasRecipients ? " c-pointer" : "")
              }
            >
              {cell}{" "}
              {hasRecipients && (
                <i className="font-weight-bold">({row.recipients.length})</i>
              )}
            </div>
          );
        },
      },
      {
        headerClasses:
          "text-nowrap bg-primary text-white text-center px-sm-3 px-2 py-4",
        classes: "px-3 py-2 text-center c-pointer",
        dataField: "is_Active",

        hidden: !AuthService.canUpdate(PermissionFeature.NotificationTriggers),
        text: "Active",
        formatter: (cell, row) => {
          let hasRecipients = row.recipients && row.recipients.length > 0;
          return (
            <div
              onClick={(e) => e.stopPropagation()}
              className={
                "w-100 px-2 py-2" + (hasRecipients ? " c-pointer" : "")
              }
            >
              <input
                type="checkbox"
                switch="bool"
                onClick={(e) => {
                  e.stopPropagation();
                }}
                checked={cell}
                onChange={(e) => {
                  e.preventDefault();
                  e.nativeEvent.stopPropagation();
                  this.handleTriggerStatusChange(row, e.target.checked);
                }}
                id={"notificationtrigger-" + row.id}
                name={"notificationtrigger-" + row.id}
              />
              <label
                className="mb-n2"
                style={{ height: "23px" }}
                htmlFor={"notificationtrigger-" + row.id}
                data-on-label="On"
                data-off-label="Off"
              />
            </div>
          );
        },
      },
      {
        dataField: "action",
        text: "Action",
        headerClasses:
          "text-nowrap bg-primary text-white text-center px-sm-3 px-2 py-4 rounded-right",
        classes: "px-3 py-2 text-center",
        hidden:
          !AuthService.canAdd(PermissionFeature.NotificationRecipient) &&
          !AuthService.canDelete(PermissionFeature.NotificationRecipient),
        formatter: (_, row) => {
          let hasRecipients = row.recipients && row.recipients.length > 0;
          return (
            <div
              className={
                "w-100 px-3 py-2" + (hasRecipients ? " c-pointer" : "")
              }
            >
              <span
                className="fas fa-cog c-pointer"
                onClick={(e) => {
                  e.stopPropagation();
                  this.openModal(row);
                }}
              ></span>
            </div>
          );
        },
      },
    ];
  };

  expandRow = () => {
    let { triggers, expanded, onExpand } = this.props;
    return {
      renderer: (row) => <RecipientTable recipients={row.recipients || []} />,
      showExpandColumn: false,
      expanded: expanded,
      onExpand: onExpand,
      expandByColumnOnly: false,

      nonExpandable: triggers
        .filter((t) => !t.recipients || t.recipients.length === 0)
        .map((t) => t.id),
    };
  };
  render() {
    let { triggers, expanded } = this.props;
    return (
      <div className="pt-3 px-1">
        <BootstrapTable
          keyField="id"
          data={triggers}
          columns={this.columns()}
          expandRow={this.expandRow()}
          bootstrap4
          classes="expandable border table-striped notification-trigger-Table"
          wrapperClasses="notification-trigger-table-wrapper"
        />
        <RecipientModal
          show={this.state.showModal}
          onHide={() => this.setState({ showModal: false })}
          trigger={this.state.selectedTrigger}
          recipients={
            this.state.selectedTrigger && this.state.selectedTrigger.recipients
              ? this.state.selectedTrigger.recipients
              : []
          }
          onSave={this.handleSaveRecipients}
        />
      </div>
    );
  }
}

export default connect(null, {
  fetchNotifications: actions.fetchNotifications,
})(TriggerTable);
